import {
    DM_CLINICAS_LOADED,
    DM_DOCTORES_LOADED,
    DM_CLINICA_LOADED,
    DM_TRATAMIENTOTIPOS_LOADED,
} from './actions'


let initialState = {
    clinica: {},
    clinicas: [],
    doctores: [],
    tratamientotipos: [],
}

export const datosmaestros = (state = initialState, action) => {
    switch (action.type) {
        case DM_CLINICA_LOADED:
            return loadedClinica(state, action.clinica);
        case DM_CLINICAS_LOADED:
            return loadedClinicas(state, action.clinicas);
        case DM_DOCTORES_LOADED:
            return loadedDoctores(state, action.doctores);
        case DM_TRATAMIENTOTIPOS_LOADED:
            return loadedTratamientotipos(state, action.tratamientotipos);
        default:
            return state;
    }
}


const loadedClinicas = (state, newClinicas) => {
    return { ...state, clinicas: newClinicas};
}

const loadedClinica = (state, newClinica) => {
    return { ...state, clinica: newClinica};
}

const loadedDoctores = (state, newDoctores) => {
    return { ...state, doctores: newDoctores};
}

const loadedTratamientotipos = (state, newTratamientotipos) => {
    return { ...state, tratamientotipos: newTratamientotipos};
}